<template lang="pug">
.d-flex
  .flex-grow-1
    filter-date-range.mr-2(ref="date" :dates.sync="datesFilter" @onUpdateRange="onDateRangeUpdate" initializeDate)
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterDateRange from '@/components/clinic/reports/filters/FilterDateRange.vue'

export default {
  components: {
    FilterDateRange
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      datesFilter: [],
      dateRangeOption: null
    }
  },
  computed: {
    allFilters() {
      const filters = []

      // Map the FilterDateRange option IDs to backend date_range values
      if (this.dateRangeOption) {
        const dateRangeMap = {
          'thisWeek': 'this_week',
          'thisMonth': 'this_month',
          'thisYear': 'this_year',
          'lastWeek': 'last_week',
          'lastMonth': 'last_month',
          'custom': 'custom'
        }

        const dateRangeValue = dateRangeMap[this.dateRangeOption.id]

        // Only add filter if we have a valid mapping
        if (dateRangeValue) {
          filters.push({
            key: 'date_range',
            value: dateRangeValue
          })

          // If custom date range, also send from_date and until_date
          if (this.dateRangeOption.id === 'custom' && this.datesFilter.length === 2) {
            filters.push({
              key: 'from_date',
              value: this.datesFilter[0]
            })
            filters.push({
              key: 'until_date',
              value: this.datesFilter[1]
            })
          }
        } else if (this.datesFilter.length === 2) {
          // For unsupported options like lastSeven, lastThirty, lastNinety, use custom with dates
          filters.push({
            key: 'date_range',
            value: 'custom'
          })
          filters.push({
            key: 'from_date',
            value: this.datesFilter[0]
          })
          filters.push({
            key: 'until_date',
            value: this.datesFilter[1]
          })
        }
      }

      return filters
    }
  },
  watch: {
    allFilters: {
      handler() {
        this.$emit('update:filters', this.allFilters)
      },
      deep: true
    }
  },
  methods: {
    onDateRangeUpdate(option) {
      this.dateRangeOption = option
    },
    resetFilters() {
      this.datesFilter = []
      this.dateRangeOption = null
      this.$refs.date.clear()
    }
  }
}
</script>

